import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { getFilePath } from 'src/app/utils';

const FALLBACK_LOGO = './assets/images/logo.png';

@Component({
  selector: 'app-branding',
  standalone: true,
  imports: [RouterModule],
  template: `
    <div class="branding">
      <a [routerLink]="['/']">
        <img [src]="logoUrl()" class="align-middle m-2 logo" alt="logo" />
      </a>
    </div>
  `,
  styleUrl: './branding.component.scss'
})
export class BrandingComponent {
  private authService = inject(AuthService);

  logoUrl = computed(() => {
    const logo = this.authService.userSig()?.schoolDetails?.logo;
    return logo ? getFilePath(logo) : FALLBACK_LOGO;
  });
}
